import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Avatar,
} from '@mui/material';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';

const steps = [
  {
    icon: <LooksOneIcon sx={{ fontSize: 40 }} />,
    title: 'Connect Calendars / Invite the Bot',
    description:
      'Link your Outlook or Google Calendar, or forward meeting invites to your dedicated email address.',
  },
  {
    icon: <LooksTwoIcon sx={{ fontSize: 40 }} />,
    title: 'We Record or Ingest Your Files',
    description:
      'Our bot joins meetings automatically, or you upload recordings. Track live status in real-time.',
  },
  {
    icon: <Looks3Icon sx={{ fontSize: 40 }} />,
    title: 'Review Transcript, Summary, and Action Items',
    description:
      'Access full transcripts with AI-generated summaries and actionable next steps within minutes.',
  },
];

export default function HowItWorks() {
  return (
    <Box sx={{ py: 8, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 6, fontWeight: 700 }}
        >
          How It Works
        </Typography>

        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: 'primary.main',
                    width: 80,
                    height: 80,
                    mb: 2,
                  }}
                >
                  {step.icon}
                </Avatar>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  sx={{ fontWeight: 600 }}
                >
                  {step.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
